import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { required } from '../../Helpers/validators';
import { eventPropType } from '../../Constants/eventTypes';
import EventTypeRadioField from './EventTypeRadioField';
import EventTypeSelectField from './EventTypeSelectField';
import { Button } from '@jauntin/react-ui';

const Edit = ({
  select,
  valid,
  iconEventTypes,
  listEventTypes,
  eventTypeRadio,
  eventTypeSelect,
}) => (
  <>
    <EventTypeRadioField
      types={iconEventTypes}
      name="eventTypeRadio"
      validate={[required]}
      checked={!!eventTypeRadio}
      action={select}
    />
    <div className="form-group">
      <Field
        types={listEventTypes}
        validate={[required]}
        component={EventTypeSelectField}
        name="eventTypeSelect"
        type="select"
      />
    </div>
    <div className="text-right">
      <Button
        disabled={!valid}
        onClick={select}
        text="Continue"
        show={!!eventTypeSelect}
        className="btn-primary"
      />
    </div>
  </>
);
Edit.propTypes = {
  select: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  iconEventTypes: PropTypes.arrayOf(eventPropType).isRequired,
  listEventTypes: PropTypes.arrayOf(eventPropType).isRequired,
  eventTypeRadio: PropTypes.string.isRequired,
  eventTypeSelect: PropTypes.string.isRequired,
};

export default Edit;
